import React, { useState,useEffect } from "react";
import RevenueChart from "../AssetDashboard/DashboardCharts/EstimatedRevenue";
import GenerationChart from "../AssetDashboard/DashboardCharts/GenerationAndAwards";
import RevenueTable from "../AssetDashboard/ChartsSetup/EstimatedRevenueTable";
import VolumeChart from "../AssetDashboard/DashboardCharts/RDVolumeLineChart";
// import VolumeTable from "../AssetDashboard/ChartsSetup/VolumeTable";
import OutagesChart from "../AssetDashboard/DashboardCharts/OutagesLineChart";
import OutagesTable from "../AssetDashboard/DashboardCharts/OutagesTable";
import PriceChart from "../AssetDashboard/DashboardCharts/PriceTabChart";
// import PriceTable from "../AssetDashboard/ChartsSetup/PriceTable";
import { FaRegFilePdf } from "react-icons/fa6";
import { TbFileExcel } from "react-icons/tb";
import { FaRegCopy } from "react-icons/fa";
import { BsFiletypeCsv } from "react-icons/bs";
// import { useAssetContext } from "../../DataContext/AssetContext";
import { useAssetContext } from "../DataContext/AssetContext";

interface ChartTabsProps {
  refreshCounter?: number;
  menuConfig: {
    title: string;
    submenu: { name: string; path: string }[];
    tabs: { name: string; key: string; icon: string }[];
    charts: { key: string; label: string }[];
    tables: { key: string; label: string }[];
  }[];
}

const ChartTabs: React.FC<ChartTabsProps> = ({ menuConfig,refreshCounter }) => {
  const [activeTab, setActiveTab] = useState(0);
  const { resetFilters } = useAssetContext(); 


  const chartComponents: { [key: string]: React.ReactNode } = {
    RevenueChart: <RevenueChart />,
    GenerationChart: <GenerationChart />,
    VolumeChart: <VolumeChart />,
    OutagesChart: <OutagesChart />,
    PriceChart: <PriceChart />,
  };

  const tableComponents: { [key: string]: React.ReactNode } = {
    RevenueTable: <RevenueTable />,
    // VolumeTable: <VolumeTable />,
    OutagesTable: <OutagesTable />,
    // PriceTable: <PriceTable />,
  };
  useEffect(() => {
    resetFilters();
  }, [refreshCounter]);
  return (
    <div className="m-[10px] md:m-[30px] shadow-[0_4px_10px_rgba(0,0,0,0.1)] rounded-[15px] overflow-hidden border-l-[2px] border-r-[2px] border-b-[2px] border-[#EAE7FF]">
      <div className="flex justify-start bg-[#F7F7FF] flex-wrap">
        {menuConfig[0]?.tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={`px-3 sm:px-4 md:px-8 py-2 sm:py-3 md:py-[10px] text-sm sm:text-base md:text-[20px] rounded-t-[10px] transition-all ${
              activeTab === index
                ? "bg-white text-[#FF2C2C] font-bold shadow-[0_6px_15px_rgba(0,0,0,0.15)] border-t-[2px] border-l-[2px] border-r-[2px] border-[#EAE7FF] mr-2 sm:mr-4 md:mr-[10px]"
                : "bg-[#EAE7FF] text-gray-600 mr-2 sm:mr-4 md:mr-[10px]"
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      <div className="bg-white p-1 md:p-5 border border-[#EAE7FF]">
        <div className="bg-[#EAE7FF] p-2 md:p-5 rounded-lg">
          {menuConfig[0]?.charts.map((chart, index) => (
            chartComponents[chart.key] && (
              <div key={index} className="border border-gray-300 rounded-xl bg-white mb-7">
                <div className="flex justify-between items-center">
                  <h1 className="text-sm md:text-xl font-bold text-gray-600 ml-4 mt-5">
                    {chart.label}
                  </h1>
                  <div className="flex space-x-4 mt-3 mx-4">
                    <FaRegFilePdf className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition" title="Export as PDF" />
                    <BsFiletypeCsv className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition" title="Export as CSV" />
                    <TbFileExcel className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition" title="Export as Excel" />
                    <FaRegCopy className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition" title="Copy Data" />
                  </div>
                </div>
                {chartComponents[chart.key]}
              </div>
            )
          ))}

          {menuConfig[0]?.tables.map((table, index) => (
            tableComponents[table.key] && (
              <div key={index} className="border border-gray-300 rounded-xl bg-white mb-7">
                <div className="flex justify-between items-center">
                  <h1 className="text-sm md:text-xl font-bold text-gray-600 ml-4 mt-3">
                    {table.label}
                  </h1>
                  <div className="flex space-x-4 mt-3 mx-4">
                    <FaRegFilePdf className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition" title="Export as PDF" />
                    <BsFiletypeCsv className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition" title="Export as CSV" />
                    <TbFileExcel className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition" title="Export as Excel" />
                    <FaRegCopy className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition" title="Copy Data" />
                  </div>
                </div>
                {tableComponents[table.key]}
              </div>
            )
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChartTabs;
